import { fetchList } from "@/api/timezone";

const state = {
  listItems: []
};

const mutations = {
  SET_LIST_TIMEZONES: (state, data) => {
    state.listItems = data;
  }
};

const actions = {
  fetchListTimezones({ commit }, query) {
    return new Promise((resolve, reject) => {
      fetchList(query)
        .then(response => {
          commit("SET_LIST_TIMEZONES", response.data);
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const timezone = {
  state,
  mutations,
  actions,
  getters: {
    listTimeZones: state => state.listItems
  }
};

export default timezone;
